/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg id="messages_group_main" data-name="Messages Group Main" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 31.414 30.99">
  <defs>
    <clipPath id="messages_clip_path">
      <rect id="messages_rect" data-name="Messages Rectangle" width="31.414" height="30.99" fill="none" stroke="currentColor" stroke-width="1.3"/>
    </clipPath>
  </defs>
  <g id="messages_group_outer">
    <g id="messages_group_inner" clip-path="url(#messages_clip_path)">
      <path id="messages_path" data-name="Messages Path" d="M33,7H17.249a4.128,4.128,0,0,0-4.136,4.094V23.633a4.128,4.128,0,0,0,4.136,4.094h8.117l6.2,6.142V27.728H33a4.128,4.128,0,0,0,4.136-4.094V11.094A4.127,4.127,0,0,0,33,7ZM11.655,36.725l5.727-5.8H23.9a3.938,3.938,0,0,0,1.467-.282m-13.709,6.08V30.876m0,0h-.716A3.931,3.931,0,0,1,7,26.976V16.455c0-2.145,1.316-3.9,3.483-3.9h.376" transform="translate(-6.361 -6.367)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"/>
    </g>
  </g>
</svg>
`

const MessagesSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}

export default MessagesSvg
